import {types} from '../../types';

const setGetUserAction = (payload) => {
    return {
        type: types.users.SET_USER,
        payload,
      }
}

const setGetReplenishmentAction = (payload) => {
  return {
    type: types.users.SET_HISTORY_REPLENISHMENT,
    payload,  
  }
} 

const setGetWithdrawalsAction = (payload) => {
  return {
    type: types.users.SET_HISTORY_WITHDRAWALS,
    payload
  }
}

export {
  setGetUserAction as SetGetUserAction,
  setGetReplenishmentAction as SetGetReplenishmentAction,
  setGetWithdrawalsAction as SetGetWithdrawalsAction
}